<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-card class="nuevo-cobro-card">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{
          tipoMovimiento === "cobro" ? "Nuevo Cobro" : "Nuevo Pago"
        }}</v-toolbar-title>
      </v-toolbar>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card-text>
          <v-row v-if="idTurno > 0">
            <v-col cols="12">
              <v-chip label color="transparent" text-color="black">
                <h3>Nuevo Cobro</h3>
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="fechaCobro"
                :value="fechaCobro"
                label="Fecha Cobro *"
                :rules="requiredRules"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="profsBuscar"
                item-text="nombreProfesional"
                item-value="idProfesional"
                menu-props="auto"
                label="Profesional *"
                hide-details
                prepend-icon="mdi-account"
                v-model="prof"
                :disabled="idTurno > 0 || idPresupuesto > 0"
                dense
                ref="profsBuscar"
                no-data-text="No hay Profesionales configurados"
              ></v-select>
            </v-col>
            <v-col cols="9" sm="4" md="4">
              <v-text-field
                v-model="paciente"
                prepend-icon="mdi-account"
                :rules="requiredRules"
                label="Concepto *"
                :disabled="idTurno > 0 || idPresupuesto > 0"
                dense
                @change="idPaciente = null"
                maxlength="150"
                :hint="
                  tipoMovimiento === 'cobro'
                    ? 'Puede buscar un paciente existente apretando la lupa'
                    : ''
                "
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="2" md="2">
              <v-btn
                v-show="!(idTurno > 0) && tipoMovimiento === 'cobro'"
                color="primary"
                @click="buscarPaciente"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="observaciones"
                prepend-icon="mdi-account"
                label="Observaciones"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" v-if="tipoMovimiento === 'cobro'">
              <v-select
                :items="formasPago"
                item-text="nombreFormaPago"
                item-value="idFormaPago"
                menu-props="auto"
                label="Forma de Pago *"
                hide-details
                prepend-icon="mdi-currency-usd"
                v-model="formaPago"
                dense
                no-data-text="No hay Formas de Pago configuradas"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="2"
              class="checkbox"
              v-if="tipoMovimiento === 'cobro' && !(idPresupuesto > 0)"
            >
              <v-checkbox
                v-model="esSena"
                label="Es Seña"
                color="primary"
                dense
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="total"
                prepend-icon="mdi-currency-usd"
                :rules="
                  tipoMovimiento === 'cobro'
                    ? totalRulesCobros
                    : totalRulesPagos
                "
                label="Importe *"
                @blur="toFixed"
                @keypress="onlyNumber"
                dense
                maxlength="10"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="
              idTurno > 0 &&
              [291, 464].includes(
                $store.state.usuario.institucion.idInstitucion,
              )
            "
            color="warning"
            @click.stop="enEspera"
            >En Espera</v-btn
          >
          <v-btn
            v-if="
              idTurno > 0 &&
              [291, 464].includes(
                $store.state.usuario.institucion.idInstitucion,
              )
            "
            color="success"
            :disabled="!valid"
            @click.stop="guardarCobro(true)"
            >Guardar y En Espera</v-btn
          >
          <v-btn color="success" :disabled="!valid" @click.stop="guardarCobro()"
            >Guardar</v-btn
          >
          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-form>
      <v-card-text v-if="idTurno > 0 || idPresupuesto > 0">
        <v-row dense>
          <v-col cols="12">
            <v-chip class="ma-0" label color="transparent" text-color="black">
              <h3>
                Cobros ya realizados para este
                {{ idTurno > 0 ? "turno" : "prespuesto" }}
              </h3>
            </v-chip>
          </v-col>
        </v-row>

        <v-data-table
          v-if="listaCobros.length"
          :headers="headersCobros"
          :items="this.listaCobros"
          class="elevation-1"
          :hide-default-footer="true"
          locale="es-ar"
          item-key="idCrobro"
          :items-per-page="10000"
          ref="myTable"
          :disable-sort="true"
        >
          <template v-slot:item.estado="{ item }">
            <v-chip :color="getColor(item.estado)" dark>
              {{ item.estado }}
            </v-chip>
          </template>
          <template v-slot:item.esSena="{ item }">
            <v-simple-checkbox
              v-model="item.esSena"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.idPresupuesto="{ item }">
            <v-tooltip top v-if="item.idPresupuesto">
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  small
                  :color="item.idPresupuestoDirecto ? 'indigo' : 'blue-grey'"
                  dark
                  v-on="on"
                  v-bind="attrs"
                >
                  #{{ item.idPresupuesto }}
                </v-chip>
              </template>
              <span>
                {{
                  item.idPresupuestoDirecto
                    ? "Cobro asociado directamente al presupuesto"
                    : "Asociado por el turno al presupuesto"
                }}
              </span>
            </v-tooltip>
            <span v-else>-</span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  color="purple"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="editarCobro(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar Cobro</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  class="mr-3"
                  color="red"
                  v-bind="attrs"
                  @click="borrarCobro(item)"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Eliminar Cobro</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  medium
                  v-on="on"
                  class="mr-3"
                  color="indigo"
                  v-bind="attrs"
                  @click="
                    imprimirCobro(
                      item,
                      pacienteTurno,
                      $refs.profsBuscar.selectedItems[0].nombreProfesional,
                    )
                  "
                  >mdi-file-pdf-box</v-icon
                >
              </template>
              <span>Generar Comprobante</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="
                    item.nombreFormaPago == 'Mercado Pago' &&
                    item.estado == 'Pendiente'
                  "
                  medium
                  class="mr-3"
                  v-on="on"
                  color="blue"
                  v-bind="attrs"
                  @click="generarPreferencia(item)"
                  >mdi-link</v-icon
                >
              </template>
              <span>Generar Link de Pago</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="
                    item.nombreFormaPago == 'Mercado Pago' &&
                    item.estado === 'Pendiente - Link Generado'
                  "
                  medium
                  color="orange"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="enviarLinkMail(item)"
                  >mdi-email</v-icon
                >
              </template>
              <span>Enviar Link por Mail</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="
                    item.nombreFormaPago == 'Mercado Pago' &&
                    item.estado == 'Pendiente - Link Generado'
                  "
                  medium
                  color="green"
                  class="mr-3"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="enviarLinkWA(item)"
                  >mdi-whatsapp</v-icon
                >
              </template>
              <span>Enviar Link por Whats App</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="item.estado !== 'Aprobado'"
                  medium
                  class="mr-3"
                  v-on="on"
                  color="green"
                  v-bind="attrs"
                  @click="aprobarCobro(item)"
                  >mdi-check-circle</v-icon
                >
              </template>
              <span>Aprobar Pago</span>
            </v-tooltip>

            <!-- Facturación electrónica ARCA -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="item.total >= 0 && !estaFacturado(item)"
                  medium
                  class="mr-3"
                  color="teal"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="abrirEmitirComprobante(item)"
                  >mdi-file-document-plus</v-icon
                >
              </template>
              <span>Emitir Factura Electrónica</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="estaFacturado(item)"
                  medium
                  class="mr-3"
                  color="teal darken-2"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="descargarPdfComprobante(item)"
                  >mdi-cloud-download</v-icon
                >
              </template>
              <span>Descargar/Reimprimir Factura</span>
            </v-tooltip>

            <!-- Asociar cobro a presupuesto (solo cobros de turno aprobados) -->
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-show="idTurno > 0 && item.estado === 'Aprobado'"
                  medium
                  class="mr-3"
                  color="indigo"
                  v-on="on"
                  v-bind="attrs"
                  @click.stop="asociarPresupuesto(item)"
                  >mdi-file-link</v-icon
                >
              </template>
              <span>Asociar Cobro a Presupuesto</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <v-alert class="mt-4" color="purple" dark outlined v-else>
          No hay cobros realizados para este
          {{ idTurno > 0 ? "turno" : "presupuesto" }}.
        </v-alert>
      </v-card-text>
      <EditarCobro
        :visible="showEditarCobro"
        :idCobro="editedItem.idCobro"
        :idTurnoEditar="editedItem.idTurno"
        :esMercadoPago="esMercadoPago"
        @close="cierraEditarCobro($event)"
      ></EditarCobro>
      <BuscarPacienteTurno
        :visible="showBuscarPaciente"
        @close="showBuscarPaciente = false"
        @seleccionarPaciente="seleccionarPaciente($event)"
      ></BuscarPacienteTurno>
      <EnviarLinkMail
        :visible="showEnviarLinkMail"
        :link="editedItem.linkMercadoPago"
        :paciente="editedItem.idPaciente"
        :pacienteNombre="editedItem.paciente"
        :idProfesional="editedItem.idProfesional"
        :idTurno="idTurno"
        @close="
          showEnviarLinkMail = false;
          delta = true;
        "
      ></EnviarLinkMail>
      <EnviarLinkWA
        :visible="showEnviarLinkWA"
        :link="editedItem.linkMercadoPago"
        :paciente="editedItem.idPaciente"
        :pacienteNombre="editedItem.paciente"
        :idProfesional="editedItem.idProfesional"
        :celularProp="celular"
        :nombrePacienteProp="nombrePaciente"
        :idTurno="idTurno"
        @close="
          showEnviarLinkWA = false;
          delta = true;
        "
      ></EnviarLinkWA>
      <AsociarCobroPresupuesto
        :visible="showAsociarPresupuesto"
        :idCobro="editedItem.idCobro"
        :idPaciente="editedItem.idPaciente"
        :pacienteNombre="editedItem.paciente"
        :idPresupuestoActual="editedItem.idPresupuesto"
        :idPresupuestoDirecto="editedItem.idPresupuestoDirecto"
        @asociado="buscarCobrosTurno()"
        @close="showAsociarPresupuesto = false"
      ></AsociarCobroPresupuesto>

      <!-- Modal de emisión de Factura Electrónica ARCA -->
      <v-dialog v-model="showEmitirFactura" max-width="480" persistent>
        <v-card>
          <v-toolbar dark color="primary" dense>
            <v-toolbar-title>Emitir Factura Electrónica</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="showEmitirFactura = false"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <p class="mb-2">
              Cobro por <b>${{ facturaCobro ? facturaCobro.total : "" }}</b>
            </p>
            <!-- La selección de tipo A/B sólo aplica a Responsable Inscripto.
                 Para Monotributo siempre es C y este bloque queda oculto. -->
            <template v-if="emisorEsResponsableInscripto">
              <v-select
                dense
                :items="tiposFacturaDisponibles"
                item-text="texto"
                item-value="valor"
                v-model="facturaTipo"
                label="Tipo de comprobante"
              ></v-select>
              <v-text-field
                v-if="facturaTipo === 'A'"
                dense
                v-model="facturaCuitReceptor"
                label="CUIT del receptor (Factura A)"
                hint="11 dígitos"
                maxlength="13"
              ></v-text-field>
            </template>
            <p v-else class="text-caption grey--text">
              Se emitirá Factura C a Consumidor Final con los datos del paciente.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="emitiendoFactura" @click="confirmarEmitirFactura">Emitir</v-btn>
            <v-btn color="error" text @click="showEmitirFactura = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
:deep(.checkbox) {
  .v-input--checkbox {
    margin-top: 0.6rem;
    padding-top: 0;
    &:first-child {
      margin-left: 1rem;
    }
    .v-input--selection-controls__input {
      margin-right: 2px;
    }
  }
}
:deep(.nuevo-cobro-card) {
  .v-card__actions {
    gap: 0.5rem;
    flex-wrap: wrap;
    .v-btn--contained {
      margin-left: 0 !important;
    }
  }
}
</style>
<script>
import axios from "../../axios-auth.js";
import EditarCobro from "../Caja/EditarCobro.vue";
import BuscarPacienteTurno from "../Turnos/BuscarPacienteTurno.vue";
import EnviarLinkMail from "../Caja/EnviarLinkMail.vue";
import EnviarLinkWA from "../Caja/EnviarLinkWA.vue";
import AsociarCobroPresupuesto from "../Caja/AsociarCobroPresupuesto.vue";
import CobrosMixin from "../Caja/CobrosMixin.js";

export default {
  props: {
    visible: {
      required: false,
    },
    idTurno: {
      required: false,
      default: 0,
    },
    idPresupuesto: {
      required: false,
      default: 0,
    },
    pacienteTurno: { required: false },
    idProfesional: { required: false },
    idPacienteTurno: { required: false },
    tipoMovimiento: { required: false, default: "cobro" },
    estadoTurno: { required: false, default: 0 },
    celular: { type: String, required: false, default: "" },
    nombrePaciente: { type: String, required: false, default: "" },
  },
  data: (vm) => ({
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    totalRulesCobros: [
      (v) => !!v || "Dato obligatorio",
      (v) => v >= 0 || "El total debe ser mayor o igual a 0",
    ],
    totalRulesPagos: [
      (v) => !!v || "Dato obligatorio",
      (v) => v > 0 || "El total debe ser mayor a 0",
    ],
    prof: "",
    profsBuscar: [],
    fechaCobro: null,
    paciente: null,
    observaciones: null,
    idPaciente: null,
    total: null,
    listaCobros: [],
    // Facturación electrónica ARCA
    estadosFacturacion: {}, // { [idCobro]: { yaFacturado, idComprobante, ... } }
    showEmitirFactura: false,
    facturaCobro: null,
    facturaTipo: "B",
    facturaCuitReceptor: null,
    emitiendoFactura: false,
    condicionIvaEmisorInstitucion: null, // 0=RI, 1=Monotributo, 2=Exento
    entornoFacturacion: "Produccion",
    headers: [
      { text: "Fecha", value: "fechaString" },
      { text: "Concepto", value: "paciente" },
      { text: "Observaciones", value: "observaciones" },
      { text: "Profesional", value: "nombreProfesional" },
      { text: "Forma Pago", value: "nombreFormaPago" },
      { text: "Es Seña", value: "esSena" },
      { text: "Importe", value: "totalString" },
      { text: "Estado", value: "estado" },
      { text: "Presupuesto", value: "idPresupuesto" },
      { text: "Acciones", value: "actions" },
    ],
    showEditarCobro: null,
    editedItem: {},
    editedIndex: -1,
    showBuscarPaciente: false,
    formasPago: [],
    formaPago: null,
    showEnviarLinkMail: false,
    showEnviarLinkWA: false,
    showAsociarPresupuesto: false,
    delta: false,
    esSena: false,
    esMercadoPago: false,
  }),
  mixins: [CobrosMixin],
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.setearModels();
          if (this.idTurno > 0) this.buscarCobrosTurno();
          if (this.idPresupuesto > 0) this.buscarCobrosPresupuesto();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close", this.delta);
        }
      },
    },
    // El emisor Responsable Inscripto (código 0) puede elegir A o B; Monotributo (1) o
    // Exento (2) siempre emiten C.
    emisorEsResponsableInscripto() {
      return this.condicionIvaEmisorInstitucion === 0;
    },
    tiposFacturaDisponibles() {
      return [
        { valor: "B", texto: "Factura B (Consumidor Final)" },
        { valor: "A", texto: "Factura A (Responsable Inscripto)" },
      ];
    },
    // La columna "Presupuesto" solo tiene sentido en el flujo de cobros de un turno,
    // para ver si el cobro ya quedó asociado a un presupuesto. En el flujo de
    // presupuesto es redundante, así que se oculta.
    headersCobros() {
      return this.idTurno > 0
        ? this.headers
        : this.headers.filter((h) => h.value !== "idPresupuesto");
    },
  },
  methods: {
    // ===== Facturación electrónica ARCA =====
    estaFacturado(item) {
      const est = this.estadosFacturacion[item.idCobro];
      return !!(est && est.yaFacturado);
    },
    async cargarEstadosFacturacion() {
      const cobros = this.listaCobros.filter(
        (item) => parseFloat(item.total) >= 0 && item.idCobro,
      );
      const estados = {};
      // Condición IVA del emisor (para saber si ofrecer A/B o forzar C).
      try {
        const idInstitucion = this.$store.state.usuario.institucion.idInstitucion;
        const resp = await axios.get("/Usuario/GetParametrosGenerales", {
          params: { idInstitucion },
          skipLoader: true,
        });
        this.condicionIvaEmisorInstitucion =
          resp.data && resp.data.condicionIvaEmisor != null
            ? resp.data.condicionIvaEmisor
            : null;
      } catch (e) {
        this.condicionIvaEmisorInstitucion = null;
      }
      await Promise.all(
        cobros.map((item) =>
          axios
            .get("/Facturacion/EstadoCobro?", {
              params: { idCobro: item.idCobro },
              skipLoader: true,
            })
            .then((response) => {
              if (response.data) estados[item.idCobro] = response.data;
            })
            .catch(() => {}),
        ),
      );
      this.estadosFacturacion = estados;
    },
    abrirEmitirComprobante(item) {
      this.facturaCobro = item;
      this.facturaTipo = "B";
      this.facturaCuitReceptor = null;
      this.showEmitirFactura = true;
    },
    confirmarEmitirFactura() {
      const self = this;
      const idInstitucion = this.$store.state.usuario.institucion.idInstitucion;

      // Validación de CUIT para Factura A antes de llamar al backend.
      if (this.emisorEsResponsableInscripto && this.facturaTipo === "A") {
        const cuit = (this.facturaCuitReceptor || "").replace(/\D/g, "");
        if (!self.esCuitValido(cuit)) {
          self.$swal.fire({
            icon: "error",
            title: "Ingrese un CUIT de receptor válido para Factura A",
            background: "#ececec",
            confirmButtonText: "Aceptar",
          });
          return;
        }
      }

      const datos = {
        idCobro: this.facturaCobro.idCobro,
        idInstitucion: idInstitucion,
        puntoDeVenta: 0, // el backend usa el punto de venta configurado en la institución
        entorno: this.entornoFacturacion,
        tipoComprobante: this.emisorEsResponsableInscripto ? this.facturaTipo : null,
        cuitReceptor:
          this.emisorEsResponsableInscripto && this.facturaTipo === "A"
            ? (this.facturaCuitReceptor || "").replace(/\D/g, "")
            : null,
      };

      this.emitiendoFactura = true;
      axios
        .post("/Facturacion/Emitir", datos)
        .then((response) => {
          const data = response.data || {};
          self.showEmitirFactura = false;
          self.$swal.fire({
            icon: "success",
            title: "Factura emitida",
            html:
              "Número: <b>" +
              (data.numeroComprobante != null ? data.numeroComprobante : "-") +
              "</b><br>CAE: <b>" +
              (data.cae || "-") +
              "</b>",
            background: "#ececec",
            confirmButtonText: "Aceptar",
          });
          self.cargarEstadosFacturacion();
        })
        .catch((error) => {
          const data = (error.response && error.response.data) || {};
          const causa =
            data.descripcion || data.mensaje || "No se pudo emitir la factura.";
          self.$swal.fire({
            icon: "error",
            title: "Error al emitir la factura",
            text: causa,
            background: "#ececec",
            confirmButtonText: "Aceptar",
          });
        })
        .finally(() => {
          self.emitiendoFactura = false;
        });
    },
    descargarPdfComprobante(item) {
      const est = this.estadosFacturacion[item.idCobro];
      if (!est || !est.idComprobante) {
        this.showAlert &&
          this.showAlert({
            icon: "error",
            title: "No se encontró el comprobante a reimprimir.",
            vm: this,
            timer: 2500,
          });
        return;
      }
      axios
        .get("/Facturacion/DescargarPdf?", {
          params: { idComprobante: est.idComprobante },
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch(() => {
          this.$swal.fire({
            icon: "error",
            title: "No se pudo descargar el PDF del comprobante.",
            background: "#ececec",
            confirmButtonText: "Aceptar",
          });
        });
    },
    // descargarPdfComprobante(item) {
    //   const est = this.estadosFacturacion[item.idCobro];

    //   if (!est || !est.idComprobante) {
    //     this.showAlert &&
    //       this.showAlert({
    //         icon: "error",
    //         title: "No se encontró el comprobante a reimprimir.",
    //         vm: this,
    //         timer: 2500,
    //       });
        
    //     return;
    //   }
    
    //   const url = `/Facturacion/DescargarPdf?idComprobante=${est.idComprobante}`;
    
    //   window.open(url, "_blank");
    // },
    // Validación de CUIT argentino (11 dígitos + dígito verificador módulo 11).
    esCuitValido(cuit) {
      if (!cuit || cuit.length !== 11) return false;
      const mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
      let suma = 0;
      for (let i = 0; i < 10; i++) suma += parseInt(cuit[i], 10) * mult[i];
      const resto = suma % 11;
      const ver = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;
      return ver === parseInt(cuit[10], 10);
    },
    enEspera() {
      this.$swal({
        title: "Turno a en espera",
        text: "¿Desea pasar el turno a en espera?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          try {
            await axios.get("/Turnos/Espera", {
              params: {
                idTurno: this.idTurno,
              },
            });
            this.showAlert({
              icon: "success",
              title: "Turno pasado a en espera.",
              vm: this,
              timer: 2500,
            });
            this.$emit("recargarLista");
            this.show = false;
          } catch (error) {
            this.showAlert({
              icon: "error",
              title:
                "El turno no pudo ser pasado a en espera. Intente nuevamente.",
              vm: this,
              timer: 2500,
            });
          }
        }
      });
    },
    aprobarCobro(item) {
      this.$swal({
        title: "Aprobar Pago",
        text: "¿Desea aprobar el pago?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosCobro = {
            idCobro: item.idCobro,
            idTurno: item.idTurno,
            esSena: item.esSena,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          };

          let self = this;
          axios
            .post("/Caja/AprobarPago", datosCobro)
            .then((response) => {
              if (response.data === "Ok") {
                self.showAlert({
                  icon: "success",
                  title: "Pago aprobado exitosamente.",
                  vm: self,
                  timer: 2500,
                });
                if (datosCobro.idTurno > 0) {
                  self.$emit("recargarLista");
                  setTimeout(self.buscarCobrosTurno(0), 2600);
                }
                if (datosCobro.idPresupuesto > 0) {
                  setTimeout(self.buscarCobrosPresupuesto(0), 2600);
                }
              } else {
                self.showAlert({
                  icon: "error",
                  title: "El pago no pudo ser aprobado.",
                  vm: self,
                  timer: 2500,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El pago no pudo ser aprobado.",
                vm: self,
                timer: 2500,
              });
            });
        }
      });
    },
    enviarLinkMail(item) {
      this.editedIndex = this.listaCobros.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEnviarLinkMail = true;
    },
    enviarLinkWA(item) {
      this.editedIndex = this.listaCobros.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showEnviarLinkWA = true;
    },
    asociarPresupuesto(item) {
      this.editedIndex = this.listaCobros.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showAsociarPresupuesto = true;
    },
    generarPreferencia(item) {
      if (
        item.accessToken === null ||
        item.accessToken === "" ||
        item.accessToken === undefined
      ) {
        this.showAlert({
          icon: "error",
          title: "El profesional no tiene configurado su token de mercado pago",
          vm: this,
          timer: 2800,
        });
        return;
      }
      this.$swal({
        title: "Generar Link de Pago",
        text: "¿Desea generar el link de pago?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosPreferencia = {
            idCobro: item.idCobro,
            accessToken: item.accessToken,
            total: item.total,
            nombreProfesional: item.nombreProfesional,
          };

          let self = this;
          axios
            .post("/Caja/GenerarPreferencia", datosPreferencia)
            .then((response) => {
              if (response.data === "Ok") {
                self.showAlert({
                  icon: "success",
                  title: "Link de Pago generado exitosamente.",
                  vm: self,
                  timer: 2500,
                });
                if (self.idTurno > 0) {
                  setTimeout(self.buscarCobrosTurno(0), 2600);
                }
                if (self.idPresupuesto > 0) {
                  setTimeout(self.buscarCobrosPresupuesto(0), 2600);
                }
              } else {
                self.showAlert({
                  icon: "error",
                  title: "El Link de Pago no pudo ser generado.",
                  vm: self,
                  timer: 2500,
                });
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El Link de Pago no pudo ser generado.",
                vm: self,
                timer: 2500,
              });
            });
        }
      });
    },
    getColor(estado) {
      if (estado == "Aprobado") {
        return "blue";
      }
      if (estado == "Pendiente") {
        return "red";
      }
      if (estado == "Pendiente - Link Generado") {
        return "orange";
      }
    },

    seleccionarPaciente(item) {
      (this.idPaciente = item.idpaciente),
        (this.paciente = item.apellidos + ", " + item.nombres);
      this.showBuscarPaciente = false;
    },
    buscarPaciente() {
      this.showBuscarPaciente = true;
    },
    guardarCobro(enEspera = false) {
      const title =
        this.tipoMovimiento === "cobro" ? "Registrar Cobro" : "Registrar Pago";
      const text =
        this.tipoMovimiento === "cobro"
          ? "¿Desea registrar el cobro?"
          : "¿Desea registrar el pago?";
      this.$swal({
        title: title,
        text: text,
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          const datosCobro = {
            fecha: this.fechaCobro,
            idTurno: this.idTurno,
            estadoTurno: this.estadoTurno,
            idPaciente: this.idPaciente,
            total:
              this.tipoMovimiento === "cobro"
                ? this.total
                : parseFloat(0 - this.total, 2).toString(),
            observaciones: this.observaciones,
            idProfesional: this.prof,
            paciente: this.paciente,
            idFormaPago:
              this.tipoMovimiento === "cobro" ? this.formaPago : null,
            usuario: this.$store.state.usuario.usuario,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            idPresupuesto: this.idPresupuesto,
            esSena: this.esSena,
            enEspera,
          };
          let self = this;
          axios
            .post("/Caja/GuardarCobro", datosCobro)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarModels();
              document.getElementsByClassName(
                "v-dialog--active",
              )[0].scrollTop = 0;
              const alertTitle =
                self.tipoMovimiento === "cobro"
                  ? "Cobro registrado"
                  : "Pago registrado";
              self.showAlert({
                icon: "success",
                title: alertTitle,
                vm: self,
              });
              if (self.tipoMovimiento === "cobro" && self.idTurno > 0) {
                this.$swal({
                  title: "Generar Comprobante",
                  text: "¿Desea generar el comprobante de cobro al paciente?",
                  icon: "success",
                  type: "success",
                  showCancelButton: true,
                  background: "#ececec",
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
                }).then((result) => {
                  if (result.value) {
                    this.imprimirCobro(
                      datosCobro,
                      self.pacienteTurno,
                      self.$refs.profsBuscar.selectedItems[0].nombreProfesional,
                    );
                  }
                });
              }
              this.delta = true;
              if (self.idTurno > 0) {
                self.buscarCobrosTurno();
                if (self.estadoTurno === 1) {
                  this.delta = false;
                  self.$emit("recargarLista");
                }
              }
              if (self.idPresupuesto > 0) {
                self.buscarCobrosPresupuesto();
              }
            })
            .catch((error) => {
              const alertTitleError =
                self.tipoMovimiento === "cobro"
                  ? "El cobro no pudo ser registrado"
                  : "El pago no pudo ser registrado";
              self.showAlert({
                icon: "error",
                title: alertTitleError,
                vm: this,
              });
            });
        }
        if (
          this.idTurno > 0 &&
          this.$store.state.usuario.institucion.idInstitucion === 170
        ) {
          const self = this;
          axios
            .get("/Turnos/Atendido?", {
              params: {
                idTurno: this.idTurno,
              },
            })
            .then((response) => {
              self.$emit("recargarLista");
            });
        }
      });
    },
    borrarCobro(item) {
      this.$swal({
        title: "Borrar Cobro",
        text: "¿Desea borrar el cobro?",
        icon: "success",
        background: "#ececec",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const idCobro = item.idCobro;
          let self = this;
          axios
            .get("/Caja/BorrarCobro?", {
              params: {
                idCobro: idCobro,
                idTurno: item.idTurno,
              },
            })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Cobro borrado",
                vm: self,
              });
              if (self.idTurno > 0) {
                setTimeout(self.buscarCobrosTurno(), 1700);
              }
              if (self.idPresupuesto > 0) {
                setTimeout(self.buscarCobrosPresupuesto(), 1700);
              }
              this.delta = true;
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title:
                  "El cobro no puede ser borrado por estar incluído en una liquidación a profesional y/o un cierre de caja",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    setearModels() {
      const profData = {
        usuario: this.$store.state.usuario.usuario,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Turnos/BuscarProfesionalesAsociados?", {
          params: {
            usuario: profData.usuario,
            idInstitucion: profData.idInstitucion,
          },
        })
        .then((response) => {
          self.profsBuscar = response.data.profesionales;

          if (self.tipoMovimiento === "pago") {
            self.profsBuscar.unshift({
              idProfesional: null,
              nombreProfesional: "NO ASOCIADO",
            });
          }

          if (self.idTurno == 0 && self.idPresupuesto == 0)
            self.prof = self.profsBuscar[0].idProfesional;
          else self.prof = self.idProfesional;
        });

      this.fechaCobro = this.parseDate(
        this.formatDate(this.toISOLocal(new Date())),
      );
      if (this.pacienteTurno != null)
        this.paciente = "Cobro Paciente: " + this.pacienteTurno;
      if (this.idPacienteTurno != null) this.idPaciente = this.idPacienteTurno;

      axios.get("/Caja/BuscarFormasPago").then((response) => {
        self.formasPago = response.data;
        self.formaPago = self.formasPago[0].idFormaPago;
      });
    },
    buscarCobrosTurno() {
      const filtrosData = {
        idTurno: this.idTurno,
      };

      let self = this;
      axios
        .get("/Caja/BuscarCobrosTurno?", {
          params: {
            idTurno: filtrosData.idTurno,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaCobros = response.data;
          else self.listaCobros = [];
          self.cargarEstadosFacturacion();
        })
        .catch(function (error) {});
    },
    buscarCobrosPresupuesto() {
      const filtrosData = {
        idPresupuesto: this.idPresupuesto,
      };

      let self = this;
      axios
        .get("/Caja/BuscarCobrosPresupuesto?", {
          params: {
            idPresupuesto: filtrosData.idPresupuesto,
          },
        })
        .then(function (response) {
          if (response.data != null && response.data != "")
            self.listaCobros = response.data;
          else self.listaCobros = [];
        })
        .catch(function (error) {});
    },
    cierraEditarCobro(delta) {
      this.delta = delta;
      this.esMercadoPago = false;
      this.showEditarCobro = false;

      if (this.idTurno > 0) {
        this.buscarCobrosTurno();
      }
      if (this.idPresupuesto > 0) {
        this.buscarCobrosPresupuesto();
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    toISOLocal(d) {
      var z = (n) => ("0" + n).slice(-2);
      var zz = (n) => ("00" + n).slice(-3);
      var off = d.getTimezoneOffset();
      var sign = off < 0 ? "+" : "-";
      off = Math.abs(off);
      return (
        d.getFullYear() +
        "-" +
        z(d.getMonth() + 1) +
        "-" +
        z(d.getDate()) +
        "T" +
        z(d.getHours()) +
        ":" +
        z(d.getMinutes()) +
        ":" +
        z(d.getSeconds()) +
        "." +
        zz(d.getMilliseconds()) +
        "Z"
      )
        .toString()
        .substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    toFixed() {
      if (isNaN(parseFloat(this.total)))
        this.total = parseFloat(0.0).toFixed(2);
      else this.total = parseFloat(this.total).toFixed(2);
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    vaciarModels() {
      if (this.idTurno == 0) this.paciente = "";
      this.observaciones = "";
      this.total = "";
      this.formaPago = this.formasPago[0].idFormaPago;
      this.esSena = false;
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
    editarCobro(item) {
      let self = this;

      if (item.linkMercadoPago) {
        this.esMercadoPago = true;
      }

      axios
        .get("/Caja/ChequearEditarCobro?", {
          params: {
            idCobro: item.idCobro,
          },
        })
        .then((response) => {
          if (response.data == "included") {
            self.showAlert({
              icon: "error",
              title:
                "El cobro no puede ser modificado por estar incluído en una liquidación",
              vm: this,
              timer: 2800,
            });
          } else {
            this.tipoMovimiento = item.total >= 0 ? "cobro" : "pago";
            this.editedIndex = this.listaCobros.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditarCobro = true;
          }
        });
    },
  },
  components: {
    EditarCobro,
    BuscarPacienteTurno,
    EnviarLinkMail,
    EnviarLinkWA,
    AsociarCobroPresupuesto,
  },
};
</script>
